export const seoDefaults = {
  siteName: 'Rosita Store',
  defaultTitle: 'Rosita Store — Moda feminina portuguesa',
  defaultDescription:
    'Descubra as últimas coleções da Rosita Store: peças feitas com cuidado, entregues em todo o Portugal.',
  defaultOgImage: '/og-default.jpg',
  twitterCard: 'summary_large_image' as const,
  locale: 'pt_PT',
  siteUrl: import.meta.env.VITE_CLIENT_URL ?? 'https://rositastore.pt',
};

export type StructuredData = Record<string, unknown>;

export interface SeoProps {
  title?: string;
  description?: string;
  canonicalUrl?: string;
  ogImage?: string;
  structuredData?: StructuredData | StructuredData[];
  noindex?: boolean;
}
